export default __webpack_public_path__ + "static/media/Inter-UI-Italic.f19471ab.woff";